<div class="credit-officers">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field class="search">
          <input matInput type="text" [readonly]="loader.tableLoading.inProgress$ | async" placeholder="Search Credit Officer..." [formControl]="formControlSearch">
          <span class="mdi mdi-magnify" matPrefix></span>
        </mat-form-field>
      </div>
   
    </div>

    <div class="row">
        <div class="col-12">
            @if (loader.tableLoading.inProgress$ | async) {
                <custom-content-loader type="list"></custom-content-loader>
              }
              <div [ngClass]="{hidden: (loader.tableLoading.inProgress$ | async), 'table-section': true, 'pb-3': true}">
                <table mat-table [dataSource]="displayedData" class="width-100 mb-2">
                  @for (column of columnsToDisplay; track column) {
                    <ng-container matColumnDef="{{column}}">
                  <th mat-header-cell *matHeaderCellDef [ngClass]="{
                    'column-width-1': column !== 'actions',
                    'column-width-2': column === 'actions',
                  }"> 
                    <div class="cell">{{getColumnTitles(column)}}</div> </th>
                        <td mat-cell *matCellDef="let element">
                          <div class="cell">
                            @if (column === 'UserId') {
                              <span class="cursor-pointer" [matTooltip]="element.description">{{element.UserId}}</span>
                            }
                            @else if (column === 'Name') {
                              <span class="cursor-pointer" [matTooltip]="element.description">{{element.Name}}</span>
                            } 
                            @else if (column === 'Email') {
                              <span class="cursor-pointer" [matTooltip]="element.description">{{element.Email}}</span>
                            }
                            @else if (column === 'Assignable') {
                              <mat-slide-toggle color="primary" class="mr-2" [checked]="element.assignable ?? false" (change)="onchangeAssignable($event, element)"></mat-slide-toggle>                    
                            }
                          </div>
                        </td>
                      </ng-container>
                    }
            
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row">
                    </tr>
                </table>
                @if (total) {
                  <app-custom-paginator [length]="total" [pageIndex]="offset" [pageSize]="limit"
                  [pageSizeOptions]="[10, 20, 25, 50, 100]" (page)="onPagination($event)"></app-custom-paginator>
                }
              </div>
        </div>
    </div>
</div>
